import React from 'react';
import { getPathFromUrlString } from '../../../utils/url';
import { Snippet } from 'react-instantsearch-dom';
import { Link } from 'gatsby';
import { ListItemText, List, withStyles } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';

const styles = {
    pageTitle: {
        'margin-top': '15px',
        'margin-bottom': '0px;',
        'font-size': '18px',
        'font-weight': '600',
        'line-height': '24px',
    },
    breadcrumb: {
        color: 'black',
        'font-size': '13px',
        'line-height': '8px',
        'margin-bottom': '0px',
        'white-space': 'nowrap',
        overflow: 'hidden',
        'text-overflow': 'ellipsis',
        display: 'block',
        'padding-bottom': '5px',
        'padding-top': '5px',
        'max-width': '120ch',
        height: '2em',
    },
    content: {
        'line-height': '20px',
        'padding-left': '0px',
        'font-size': '15px',
        'min-height': '70px',
    },
};

const contentSnippet = (hit) => {
    if (hit.content) {
        return (
            <p>
                <Snippet tagName="b" attribute="content" hit={hit}></Snippet>
            </p>
        );
    }
};

const createBreadcrumb = (hit) => {
    const { hierarchy } = hit;
    const stack = [];
    for (let lvl in hierarchy) {
        if (hierarchy[lvl]) {
            stack.push(hierarchy[lvl]);
        }
    }
    const breadcrumb = stack.join(' > ');
    if (breadcrumb.length > 100) {
        return breadcrumb.substring(0, 100) + '...';
    }

    return breadcrumb;
};

const getCleanUrlFromHit = (hit) => {
    let url = getPathFromUrlString(hit.url) + `#${hit.anchor}`;
    return url.replace('/#gatsby-focus-wrapper', '');
};

export const Hit = withStyles(styles)(({ hit, classes }) => {
    const url = getCleanUrlFromHit(hit);
    return (
        <div>
            <Link to={url} color="secondary">
                <h5 className={classes.pageTitle}>{hit.hierarchy.lvl0}</h5>
                <div>
                    <p className={classes.breadcrumb}>
                        <b className={classes.breadcrumb}>{createBreadcrumb(hit)}</b>
                    </p>
                    <ListItemText key={hit.objectID} className={classes.content}>
                        <span>{contentSnippet(hit)}</span>
                    </ListItemText>
                </div>
            </Link>
            <Divider />
        </div>
    );
});

export const Hits = (data) => {
    if (data.hits.length > 0) {
        return (
            <List>
                {data.hits.map((hit) => (
                    <Hit key={hit.id} hit={hit} />
                ))}
            </List>
        );
    } else return <></>;
};
